import { Component } from 'react';
import { DRAGDROP_TYPE } from 'crm_components/dialog/propertyListEditor/PropertyListEditorConstants';
import { ENTER } from '../../utils/keyCodes';
import PropTypes from 'prop-types';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import DnDListDragSourceWrapper from 'customer-data-ui-utilities/dnd/DnDListDragSourceWrapper';
import RestrictedPropertyIcon from './RestrictedPropertyIcon';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import withRestrictedProperties from './withRestrictedProperties';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export class DnDSearchResultsItem extends Component {
  constructor(...args) {
    super(...args);
    this.handleSelect = evt => {
      const {
        property,
        disabled
      } = this.props;
      evt.preventDefault();
      if (disabled || property.readOnly || Math.abs(property.order) === Infinity) {
        return;
      }
      if (this.props.selected) {
        this.props.onUnselect(property);
      } else {
        this.props.onSelect(property);
      }
    };
    this.handleEnter = e => {
      if (e.keyCode !== ENTER) {
        return;
      }
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
      this.handleSelect();
    };
    this.renderContent = () => {
      const {
        isRestricted,
        property,
        selected
      } = this.props;
      return /*#__PURE__*/_jsx("div", {
        onClick: this.handleSelect,
        "data-selenium-test": `DnDSearchResultsItem__${property.value}`,
        children: /*#__PURE__*/_jsx(Checkbox, {
          "aria-label": property.text || property.value,
          checked: selected != null,
          disabled: this.props.disabled,
          inline: true,
          onChange: this.handleSelect,
          children: /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            gap: "100",
            children: [isRestricted && /*#__PURE__*/_jsx(RestrictedPropertyIcon, {}), /*#__PURE__*/_jsx(TruncateString, {
              children: property.text || property.value
            })]
          })
        })
      });
    };
  }
  render() {
    if (this.props.selected != null) {
      return this.renderContent();
    }
    return this.props.connectDragSource(this.renderContent());
  }
}
DnDSearchResultsItem.displayName = 'DnDSearchResultsItem';
DnDSearchResultsItem.propTypes = {
  connectDragSource: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  isRestricted: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  onUnselect: PropTypes.func.isRequired,
  property: PropTypes.object.isRequired,
  selected: PropTypes.object,
  disabled: PropTypes.bool
};
DnDSearchResultsItem.defaultProps = {
  isRestricted: false,
  selected: undefined
};
export default DnDListDragSourceWrapper(DRAGDROP_TYPE, props => ({
  option: props.property
}), {
  isDragging(item, monitor) {
    return item.option === monitor.getItem().data.option;
  }
})(withRestrictedProperties(DnDSearchResultsItem));